import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <span className="gold-tag">System Notification</span>
                <h2>Inquiry Processed</h2>
                <p>
                    This is <strong>The Pillar</strong> interactive demo. <br />
                    Please note: No data has been saved or transmitted. This form is for 
                    demonstration of look, feel, and UI logic only.
                </p>
                <button className="btn-main" onClick={onClose}>RETURN TO HOME</button>
            </div>
        </div>
    );
};

export default Modal;